import React, { useState, useEffect } from 'react';
import axios from 'axios';
import PropTypes from 'prop-types';
import DatabaseList from './database_list';
import './corporate_databases.scss';

const getCorporateDatabases = async (url, setReqErr) => {
  try {
    const response = await axios.get(url);
    if (response.status !== 200) {
      setReqErr(response);
      return;
    }
    return response.data;
  } catch (err) {
    setReqErr(err);
    return;
  }
};

const CorporateDatabasesPresenter = ({ corporateDatabasesUrl, newCorporateDatabaseUrl }) => {
  const [databases, setDatabases] = useState([]);
  const [reqErr, setReqErr] = useState(null);

  useEffect(() => {
    const fetchDbs = async () => {
      const responseData = await getCorporateDatabases(corporateDatabasesUrl, setReqErr);
      if (reqErr != null) {
        return;
      }
      setDatabases(responseData);
    };

    fetchDbs();
  }, []);

  return (
    <div>
      <div className="corporate-databases__header">
        Database Settings
      </div>
      <DatabaseList
        databases={databases}
        newCorporateDatabaseUrl={newCorporateDatabaseUrl}
      />
    </div>
  );
};

CorporateDatabasesPresenter.propTypes = {
  corporateDatabasesUrl: PropTypes.string.isRequired,
  newCorporateDatabaseUrl: PropTypes.string.isRequired
};

// TODO: React on Rails is rendering the exported element into it's own
// wrapper that causes the hook to be misfire. This makes the hooks look like
// their being called in each other causes the hooks rule violation.
export default function CorporateDatabases({ corporateDatabasesUrl, newCorporateDatabaseUrl }) {
  return (
    <CorporateDatabasesPresenter
      corporateDatabasesUrl={corporateDatabasesUrl}
      newCorporateDatabaseUrl={newCorporateDatabaseUrl}
    />
  );
}

CorporateDatabases.propTypes = {
  corporateDatabasesUrl: PropTypes.string.isRequired,
  newCorporateDatabaseUrl: PropTypes.string.isRequired
};
